/**
 * @fileOverview Displays a table of data.
 */

import React from 'react'
import classnames from 'classnames'
import injectStyles from 'react-jss'
import { Table as TableC } from 'Components/Table'
import { Td } from 'Components/Table/Td'
import { Tr } from 'Components/Table/Tr'
import './types'
import SortableHeader from './SortableHeader'

const styles = {
  table: {
    cursor: 'pointer',
    '@global': {
      'td:last-child, th:last-child': {
        paddingRight: 65,
      },
      'td:first-child, th:first-child': {
        paddingLeft: 65,
      },
    },
  },
  tableHeader: {
    position: 'sticky',
    top: 0,
    background: '#FFFFFF',
    zIndex: 1,
  },
  rowWarning: {
    backgroundColor: 'rgba(255, 206, 5, 0.2) !important',
  },
}

/**
 * @typedef TableProps
 * @property {Array<SortableHeader>} header The column headers
 * @property {Array<Array<string>>} data Multi dimensional array to equate to
 * the table rows of data to display
 * @property {Array<Function>} actions If specified will fire the action when
 * the related row is tapped/clicked.
 *
 * @param {TableProps} props
 */
const Table = props => {
  const {
    classes,
    actions,
    footer,
    data = [],
    disableActionColumnIndexes = [],
    highlightColumnsIndexes = [],
  } = props
  const handleAction = (rowIndex, columnIndex) => {
    if (
      !actions ||
      !actions[rowIndex] ||
      disableActionColumnIndexes.includes(columnIndex)
    ) {
      return
    }

    return actions[rowIndex]()
  }
  return (
    <TableC className={classnames(classes.table, 'Table')}>
      {props.header && props.header.length ? (
        <thead className={classes.tableHeader}>
          <tr>
            {props.header.map(headerProps => (
              <SortableHeader
                key={`TableC-thead-SortableHeader-${headerProps.label}`}
                style={{
                  cursor: headerProps.onSortDirectionChange
                    ? 'pointer'
                    : 'inherit',
                }}
                onClick={headerProps.onSortDirectionChange}
                onTouchTap={headerProps.onSortDirectionChange}
                direction={headerProps.sortDirection}
              >
                {headerProps.label}
              </SortableHeader>
            ))}
          </tr>
        </thead>
      ) : null}
      <tbody>
        {data && data.length > 0
          ? data.map((row, rowIndex) => (
              <Tr
                className={classnames({
                  [classes.rowWarning]: highlightColumnsIndexes.includes(
                    rowIndex,
                  ),
                })}
              >
                {row.map((item, columnIndex) => (
                  <Td
                    onClick={handleAction.bind(this, rowIndex, columnIndex)}
                    onTouchTap={handleAction.bind(this, rowIndex, columnIndex)}
                  >
                    {item}
                  </Td>
                ))}
              </Tr>
            ))
          : null}
      </tbody>
      {footer && footer.length ? (
        <tfoot>
          {footer.map(row => (
            <Tr>
              {row.map(value => (
                <Td>{value}</Td>
              ))}
            </Tr>
          ))}
        </tfoot>
      ) : null}
    </TableC>
  )
}

const StyledTable = injectStyles(styles)(Table)

export default StyledTable



// WEBPACK FOOTER //
// ./src/Components/TableTable/Table.js